import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import { PromotionalCampaignsList, PromotionalCampaignsShow } from './PromotionalCampaignRouteComponents';

export const promotionalCampaignRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: PromotionalCampaignsList,
    path: adminRoutes.promotionalCampaigns,
    permitOnly: [UserRoles.BrokerSales],
  },
  {
    Component: PromotionalCampaignsShow,
    path: `${adminRoutes.promotionalCampaigns}/:id`,
    permitOnly: [UserRoles.BrokerSales],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
